// extracted by mini-css-extract-plugin
module.exports = {"title":"e_XF","icon":"e_YF"};